import { useMutation, useQuery } from "@tanstack/react-query";
import { RssFeedDto } from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { RssFeedClient } from "../../../services/proxies";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace RssFeedService {
  const rssFeedClient = new RssFeedClient();

  export const save = () =>
    useMutation<IActionResult<RssFeedDto>, Error, RssFeedDto>({
      mutationFn: async (payload: RssFeedDto) => {
        return await rssFeedClient.saveRssFeedAsync(payload);
      },
    });

  export const getRssFeedQuery = (rssFeedId: string | undefined) =>
    useQuery({
      queryKey: ["rssFeedQuery", rssFeedId],
      queryFn: async () => await rssFeedClient.getRssFeedAsync(rssFeedId),
      enabled: Boolean(rssFeedId && rssFeedId !== Constants.emptyGuid),
    });

  export const getAllRssFeedsQuery = () =>
    useQuery({
      queryKey: ["rssFeedsQuery"],
      queryFn: async () => await rssFeedClient.getRssFeedsAsync(),
    });

  export const getCommunityRssFeedsQuery = (communityId: string | undefined) =>
    useQuery({
      queryKey: ["rssFeedsQuery", communityId],
      queryFn: async () =>
        await rssFeedClient.getCommunityRssFeedsAsync(communityId),
      enabled: Boolean(communityId),
    });

  export const gridQuery = (searchQuery: SearchDto) =>
    useQuery({
      queryKey: ["rssFeedGridQuery", searchQuery],
      queryFn: async () => await rssFeedClient.searchRssFeedAsync(searchQuery),
    });

  export const getLookups = () =>
    useQuery({
      queryKey: ["rssFeedLookupsQuery"],
      queryFn: async () => await rssFeedClient.getLookupsAsync(),
      select: (data) => {
        return {
          communities: LookupDto.mapToOptions(data?.communities),
          rssFeedType: LookupDto.mapToOptions(data?.rssFeedType),
        };
      },
    });

  export const deleteRssFeed = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await rssFeedClient.deleteRssFeedAsync(id);
      },
    });
}
